import type { PublicApiKey } from '@/apilib';
import type { createColumnsApi } from './columnsWrapper';

export const ColumnsApiKey: PublicApiKey<typeof createColumnsApi> = {
  name: 'ColumnsApi',
  public: true,
};
